import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getGstOneInvoiceListApi,
  getGstOneListApi,
  getGstThreeBInvoiceListAPi,
  getGstr2aReturnsApi,
  getGstr2bReturnsApi,
  getGstrOnehsnWiseCountApi,
  getGstrTreeBListApi,
  getInwardsListApi,
  getOutwardsListApi,
  postUpdateInwardGstr2a2bStatusApi,
  postOneFilingSendOTPApi,
  postGstrOneFilingSaveDataApi,
  requestGstrOtpApi,
  updateInwardsListApi,
  updateOutwardsListApi,
  verifyGstrOtpApi,
  getGstNumberListApi,
  approveGstApi,
  gstPostComment,
  gstGetAllCommentApi,
  postGstrThreeFillingMappingApi,
  postGstOneCompleteFilingApi,
  postGstOneProceedFilingApi,
  postGstrOneFilingResetSaveDataApi,
  GstrOneFilingSatusApi,
  getGstr2a2bCompareApi,
  postARNNumberApi,
  getGstr2a2bSyncStatusApi,
  getAdminGstr1FilingReportApi,
  getAdminGstr3bFilingReportApi,
  getGstrThreeBDetailsApi,
  postGstrThreeBFilingSaveDataApi,
  postGstrThreeBFilingCompleteFilingApi,
  GstrThreeBFilingStatusApi,
  gstr3BCashItcBalanceApi,
  postSaveCinNumberApi,
  postGstr3bOffsetLiabilityApi,
  getGstNoticesListApi,
  getGstNoticeDetailsApi,
} from "@/apis/gstModuleApis";

import type {
  GetGstrThreeBListPayloadType,
  GetGstrTwoAListPayloadType,
  GetGstrTwoBListPayloadType,
  GetOutwardDataPayload,
  GstrOnePayload,
  GstrOnehsnWiseCountPayload,
  GstrThreeBInvoiceListPayload,
  PostGstrOneSaveDataType,
  GstrFilingSendOTPPayload,
  PostGstrOneCompleteFilingType,
  RequestGstOtpPayloadType,
  UpdateOutwardDataPayload,
  VerifyGstOtpPayloadType,
  GetGstNumberPayload,
  ApproveGstPayloadType,
  GstCommentPayloadType,
  GstGetAllCommentPayloadType,
  PostGstrOneProceedType,
  GstrOneSatusType,
  GetGstrTwoATwoBComparePayloadType,
  ARNNumberPayloadType,
  UpdateInwardGstr2A2BStatusPayloadType,
  GetGstr2A2BSyncStatusPayloadType,
  GetAdminGstr1FilingReportPayloadType,
  GetGstrThreeBDetailsPayloadType,
  PostGstrThreeBFilingSaveDataType,
  PostGstrThreeBFilingCompleteFilingType,
  GstrThreeBCommonPayloadType,
  SaveCINNumberPayloadType,
  GetGstNoticesListPayloadType,
  GetGstNoticeDetailsPayloadType,
} from "@/commonTypes/gstTypes";

export const getOutwardsListAction = createAsyncThunk(
  "gstModule/getOutwardsList",
  async (data: GetOutwardDataPayload) => {
    const response = await getOutwardsListApi(data);
    return response.data;
  }
);

export const updateOutwardListAction = createAsyncThunk(
  "gstModule/updateOutwardsList",
  async (data: UpdateOutwardDataPayload) => {
    const response = await updateOutwardsListApi(data);
    return response.data;
  }
);

export const getInwardsListAction = createAsyncThunk(
  "gstModule/getInwardsList",
  async (data: GetOutwardDataPayload) => {
    const response = await getInwardsListApi(data);
    return response.data;
  }
);

export const updateInwardsListAction = createAsyncThunk(
  "gstModule/updateInwardsList",
  async (data: UpdateOutwardDataPayload) => {
    const response = await updateInwardsListApi(data);
    return response.data;
  }
);

export const getGstrOneListAction = createAsyncThunk(
  "gstModule/getGstrOneList",
  async (data: GstrOnePayload) => {
    const response = await getGstOneListApi(data);
    return response.data;
  }
);

export const getGstrOneInvoiceListAction = createAsyncThunk(
  "gstModule/getGstrOneInvoiceList",
  async (data: GstrOnePayload) => {
    const response = await getGstOneInvoiceListApi(data);
    return response.data;
  }
);

export const getGstThreebInvoiceListAction = createAsyncThunk(
  "gstModule/getGstrThreeBInvoiceList",
  async (data: GstrThreeBInvoiceListPayload) => {
    const response = await getGstThreeBInvoiceListAPi(data);
    return response.data;
  }
);

export const getGstrOnehsnWiseCountAction = createAsyncThunk(
  "gstModule/getGstrOnehsnWiseCount",
  async (data: GstrOnehsnWiseCountPayload) => {
    const response = await getGstrOnehsnWiseCountApi(data);
    return response.data;
  }
);

export const getGstrThreeBListAction = createAsyncThunk(
  "get/gstrThreeB",
  async (data: GetGstrThreeBListPayloadType) => {
    const response = await getGstrTreeBListApi(data);
    return response.data;
  }
);

export const requestGstOtpAction = createAsyncThunk(
  "request/otp",
  async (data: RequestGstOtpPayloadType) => {
    const response = await requestGstrOtpApi(data);
    return response.data;
  }
);

export const verifyGstOtpAction = createAsyncThunk(
  "verify/otp",
  async (data: VerifyGstOtpPayloadType) => {
    const response = await verifyGstrOtpApi(data);
    return response.data;
  }
);

export const getGstrTwoAReturnsListAction = createAsyncThunk(
  "get/gstr2a/returns",
  async (data: GetGstrTwoAListPayloadType) => {
    const response = await getGstr2aReturnsApi(data);
    return response.data;
  }
);
export const getGstrTwoATwoBCompareListAction = createAsyncThunk(
  "get/gstr2a2b/compare/expense",
  async (data: GetGstrTwoATwoBComparePayloadType) => {
    const response = await getGstr2a2bCompareApi(data);
    return response.data;
  }
);

export const getGstrTwoBReturnsListAction = createAsyncThunk(
  "get/gstr2b/returns",
  async (data: GetGstrTwoBListPayloadType) => {
    const response = await getGstr2bReturnsApi(data);
    return response.data;
  }
);

export const postGstrOneFilingSaveDataAction = createAsyncThunk(
  "post/gstrOne/filing/mapping",
  async (data: PostGstrOneSaveDataType) => {
    const response = await postGstrOneFilingSaveDataApi(data);
    return response.data;
  }
);

export const postGstrThreeBFilingMappingAction = createAsyncThunk(
  "post/gstrTHreeB/filing/mapping",
  async (data: PostGstrOneSaveDataType) => {
    const response = await postGstrThreeFillingMappingApi(data);
    return response.data;
  }
);

export const postGstrOneFilingSendOTPAction = createAsyncThunk(
  "get/gstrOne/filing/otp/send",
  async (data: GstrFilingSendOTPPayload) => {
    const response = await postOneFilingSendOTPApi(data);
    return response.data;
  }
);

export const postGstrOneCompleteFilingAction = createAsyncThunk(
  "post/gstrOne/filing/otp",
  async (data: PostGstrOneCompleteFilingType) => {
    const response = await postGstOneCompleteFilingApi(data);
    return response.data;
  }
);

export const gstOneProceedFileAction = createAsyncThunk(
  "post/gstrOne/proceed",
  async (data: PostGstrOneProceedType) => {
    const response = await postGstOneProceedFilingApi(data);
    return response.data;
  }
);

export const getGstNumberList = createAsyncThunk(
  "get/gst/number",
  async (data: GetGstNumberPayload) => {
    const response = await getGstNumberListApi(data);
    return response.data;
  }
);

export const approveGstAction = createAsyncThunk(
  "post/gst/approve",
  async (data: ApproveGstPayloadType) => {
    const response = await approveGstApi(data);
    return response.data;
  }
);

export const gstPostCommentAction = createAsyncThunk(
  "/gst/post/comments",
  async (data: GstCommentPayloadType) => {
    const response = await gstPostComment(data);
    return response.data;
  }
);

export const gstGetAllCommentAction = createAsyncThunk(
  "/gst/get/all/comments",
  async (data: GstGetAllCommentPayloadType) => {
    const response = await gstGetAllCommentApi(data);
    return response.data;
  }
);

export const postGstrOneFilingResetSaveDataAction = createAsyncThunk(
  "/post/gstrOne/reset/save",
  async (data: PostGstrOneSaveDataType) => {
    const response = await postGstrOneFilingResetSaveDataApi(data);
    return response.data;
  }
);
export const gstOneFilingStatus = createAsyncThunk(
  "/get/gstrOne/status",
  async (data: GstrOneSatusType) => {
    const response = await GstrOneFilingSatusApi(data);
    return response.data;
  }
);
export const postARNNumberAction = createAsyncThunk(
  "/post/arn/number",
  async (data: ARNNumberPayloadType) => {
    const response = await postARNNumberApi(data);
    return response.data;
  }
);

export const updateInwardGstr2a2bStatusAction = createAsyncThunk(
  "post/inward/gstr2a2b/status",
  async (data: UpdateInwardGstr2A2BStatusPayloadType) => {
    const response = await postUpdateInwardGstr2a2bStatusApi(data);
    return response.data;
  }
);

export const getGstr2a2bSyncStatusAction = createAsyncThunk(
  "get/gstr2a2b/sync/status",
  async (data: GetGstr2A2BSyncStatusPayloadType) => {
    const response = await getGstr2a2bSyncStatusApi(data);
    return response.data;
  }
);

export const getAdminGstr1FilingReportAction = createAsyncThunk(
  "gstModule/getAdminGstr1FilingReport",
  async (data: GetAdminGstr1FilingReportPayloadType) => {
    const response = await getAdminGstr1FilingReportApi(data);
    return response.data;
  }
);

export const getAdminGstr3bFilingReportAction = createAsyncThunk(
  "gstModule/getAdminGstr3bFilingReport",
  async (data: GetAdminGstr1FilingReportPayloadType) => {
    const response = await getAdminGstr3bFilingReportApi(data);
    return response.data;
  }
);

export const getGstrThreeBDetailsAction = createAsyncThunk(
  "gstModule/getGstrThreeBDetails",
  async (data: GetGstrThreeBDetailsPayloadType) => {
    const response = await getGstrThreeBDetailsApi(data);
    return response.data;
  }
);

export const postGstrThreeBFilingSaveDataAction = createAsyncThunk(
  "gstModule/postGstrThreeBFilingSaveData",
  async (data: PostGstrThreeBFilingSaveDataType, { rejectWithValue }) => {
    try {
      const response = await postGstrThreeBFilingSaveDataApi(data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data ?? error);
    }
  }
);

export const postGstrThreeBFilingCompleteFilingAction = createAsyncThunk(
  "post/gstrThreeB/filing/otp",
  async (data: PostGstrThreeBFilingCompleteFilingType) => {
    const response = await postGstrThreeBFilingCompleteFilingApi(data);
    return response.data;
  }
);

export const getGstrThreeBFilingStatusAction = createAsyncThunk(
  "/get/gstrThreeB/status",
  async (data: GstrThreeBCommonPayloadType) => {
    const response = await GstrThreeBFilingStatusApi(data);
    return response.data;
  }
);

export const getGstr3BCashItcBalanceAction = createAsyncThunk(
  "/get/gstrThreeB/cashItcBalance",
  async (data: GstrThreeBCommonPayloadType) => {
    const response = await gstr3BCashItcBalanceApi(data);
    return response.data;
  }
);

export const postSaveCinNumberAction = createAsyncThunk(
  "post/gstrThreeB/cinNumber",
  async (data: SaveCINNumberPayloadType) => {
    const response = await postSaveCinNumberApi(data);
    return response.data;
  }
);

export const postGstr3bOffsetLiabilityAction = createAsyncThunk(
  "post/gstrThreeB/offsetLiability",
  async (data: GstrThreeBCommonPayloadType) => {
    const response = await postGstr3bOffsetLiabilityApi(data);
    return response.data;
  }
);

export const getGstNoticesListAction = createAsyncThunk(
  "get/gst/notices/list",
  async (data: GetGstNoticesListPayloadType) => {
    const response = await getGstNoticesListApi(data);
    return response.data;
  }
);

export const getGstNoticeDetailsAction = createAsyncThunk(
  "get/gst/notice/details",
  async (data: GetGstNoticeDetailsPayloadType) => {
    const response = await getGstNoticeDetailsApi(data);
    return response.data;
  }
);
